import type { MaybeRefOrGetter } from 'vue';
import { unref } from 'vue';

export function useSoguTags<
  T extends Array<{
    id?: number;
    counter?: number;
  }>,
>(tags: MaybeRefOrGetter<T>) {
  const soguTags = computed(() => {
    return (unref(tags) as T).reduce(
      (acc, { id, counter }) => {
        acc[String(id)] = counter;

        return acc;
      },
      {} as Record<string, number | undefined>,
    );
  });

  return {
    soguTags,
  };
}
